export default __webpack_public_path__ + "assets/d454024bbda802ffc1f0da2d59fda9c7.jpg";